export default __webpack_public_path__ + "static/media/product-image-28.8e53289f.jpg";